import { MagicConfigMixin, duration, TimeValue } from '@gig/magic-common';
import { Mixins, Prop, Component } from 'vue-property-decorator';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let TimeComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.time = this.getHMS();
  }
  created() {
    this.timer = setInterval(() => {
      this.time = this.getHMS();
    }, 1e3);
  }
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
  get outputTime() {
    const { hours, minutes, seconds } = this.time;
    const output = [hours, minutes];
    if (this.withSeconds) {
      output.push(seconds);
    }
    return output.map(this.pad).join(":");
  }
  pad(n) {
    return `${n}`.padStart(2, "0");
  }
  getHMS() {
    const { hours, minutes, seconds } = duration(this.getTimestamp());
    return { hours, minutes, seconds };
  }
  getTimestamp() {
    if (!this.since) {
      const date = new Date();
      return date.getTime() - date.getTimezoneOffset() * TimeValue.MINUTE;
    }
    const timestamp = Date.now() - this.since;
    return timestamp < 0 ? 0 : timestamp;
  }
};
__decorateClass([
  Prop(Number)
], TimeComponent.prototype, "since", 2);
__decorateClass([
  Prop({
    type: Boolean,
    default: false
  })
], TimeComponent.prototype, "withSeconds", 2);
TimeComponent = __decorateClass([
  Component({
    name: "ui-time",
    inheritAttrs: false
  })
], TimeComponent);

export default TimeComponent;
